import type { LinkCompoundProps } from '../../../Compounds/src/LinkCompound'
import type { PopoverProps } from '../../../Compounds/src/Popover'
import type { HeaderDocument, MenuType } from '../data/data.types'

export type HeaderProps = {
  headerDocument: HeaderDocument | null
  mainMenu?: MenuType
  backgroundColor: string
  textColor: string
  menuIconColor: string
  layoutClass: string
  dropdownOptions?: PopoverProps
  mobileButton?: LinkCompoundProps
  rightContentType?: RightContentEnum
  rigProps?: RigProps
  rpProps?: RetirementProfile
  cleanLocalStorage?: () => void
  handDownloadPDF?: any
  resetModal?: {
    cancel?: string
    submit?: string
    heading?: string
    subHeading?: string
    resetToolAriaLabel?: string
  }
  annualReportInfo?: {
    yearsImage: string
    mailBody: string
    mailSubject: string
    pdfFilePath: string
    year: string
    yearsImageAltText: string
    yearsImageTitle: string
  }
}

export enum RightContentEnum {
  impactAnalyzerAAG = 'impactAnalyzerAAG',
  impactAnalyzerAFG = 'impactAnalyzerAFG',
  withHeaderDocumentUtilityNav = 'withHeaderDocumentUtilityNav',
  withDefaultLinks = 'withDefaultLinks',
  dropdownOptions = 'dropdownOptions',
  retirementIncome = 'retirementIncome',
  annualReport2025 = 'annualReport2025',
  retirementProfile = 'retirementProfile',
}
export type RigProps = {
  setupPage: boolean
  welcomePage: boolean
  printContent: () => void
  handleToolReset: () => void
  printAllContent: () => void
  singlePagePrinting: boolean
  allPagesPrinting: boolean
  buttons?: {
    downloadAllAriaLabel?: string
    downloadPageAriaLabel?: string
    startOverAriaLabel?: string
  }
}

export type RetirementProfile = {
  flowType: string
  resultsShared: boolean
  hasAdvisor: boolean
  shareResultsFailure: boolean
  setShowModal: (x: string) => void
  resetExperience: () => void
  shareResultsWithAdvisor: () => void
  results?: any
  buttons?: {
    shareText: string
    sharedText: string
    startOverAriaLabel: string
    restartText: string
    downloadText: string
    appointmentText: string
    findAdvisorText: string
  }
}
